export default (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
    <path
      fill={props.color ? props.color : '#FFFFFF'}
      d="m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
    />
  </svg>
);
